import React from 'react';
import { useTranslation } from 'react-i18next';
import { CustomButton as Button } from '@sidraaabdullah/test-shared-library';
import { SPAN } from 'utils/resuable-css';

const CustomButton = ({ title = 'string6', buttonStyles, isLoading = false, disabled = false, ...remaining }) => {
  const { t } = useTranslation();
  return (
    <Button
      Paragraph={SPAN}
      title={t(title)}
      disabled={disabled}
      isLoading={isLoading}
      buttonStyles={buttonStyles}
      {...remaining}
    />
  );
};

export default CustomButton;
